import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { StyledChipsDivider } from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/styles";

export const StyledAddButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
`;

export const StyledEmptyText = styled.p`
    ${mixins.setFontVariant("caption", colorsPalettes.bluegrey[600])};
    line-height: normal;
    margin: 0;
`;

export const StyledAdsSellersValueDivider = styled(StyledChipsDivider)`
    margin: 8px 0;
`;
